import { ApoderadoSnapshot } from '../../operaciones-societarias-form/models/constitution-snapshot.model';
import { RESPONSIBILITY } from '../models/representative';
import { formatSnapshotDate } from './snapshot-date.util';

export function formatResponsibilityLabel(value: string | null | undefined): string {
  if (!value) return '';
  const opt = RESPONSIBILITY.find((r: { value: string }) => r.value === value);
  return opt?.label ?? value;
}

function buildAttorneySnapshot(data: {
  name?: string;
  nif?: string;
  documentNumber?: string;
  responsibilityType?: string;
  associatedClientName?: string;
  specialResponsibilitySummary?: string;
  startDate?: unknown;
  endDate?: unknown;
}): ApoderadoSnapshot {
  const rawType = data.responsibilityType ?? '';
  return {
    nombre: data.name ?? '',
    nif: data.nif ?? data.documentNumber ?? '',
    tipoPoder: formatResponsibilityLabel(rawType),
    fechaAlta: formatSnapshotDate(data.startDate),
    fechaBaja: data.endDate ? formatSnapshotDate(data.endDate) : undefined,
    associatedClientName: data.associatedClientName,
    responsibilityTypeRaw: rawType,
    specialResponsibilitySummary: data.specialResponsibilitySummary ?? undefined,
  };
}

export function mapAttorneyApiToSnapshot(item: any): ApoderadoSnapshot {
  const associated = item?.associatedClient || item?.client || {};
  const name =
    item?.name ||
    associated?.name ||
    [associated?.firstSurname, associated?.secondSurname, associated?.name]
      .filter(Boolean)
      .join(' ');
  const nif =
    item?.nif ||
    item?.documentNumber ||
    associated?.nif ||
    associated?.documentNumber ||
    '';

  return buildAttorneySnapshot({
    name,
    nif,
    responsibilityType: item?.responsibilityType || item?.responsibility,
    associatedClientName: associated?.name,
    specialResponsibilitySummary: item?.specialResponsibilitySummary,
    startDate: item?.startDate,
    endDate: item?.endDate,
  });
}

export function mapOperationAttorneyToSnapshot(item: any): ApoderadoSnapshot {
  return buildAttorneySnapshot({
    name: item?.name,
    nif: item?.nif,
    documentNumber: item?.documentNumber,
    responsibilityType: item?.responsibilityType,
    specialResponsibilitySummary: item?.specialResponsibilitySummary,
    startDate: item?.startDate,
    endDate: item?.endDate,
  });
}

export function mapAttornieRowToSnapshot(row: {
  name: string;
  nif: string;
  responsibilityType: string;
  specialResponsibilitySummary?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
}): ApoderadoSnapshot {
  return buildAttorneySnapshot({
    name: row.name,
    nif: row.nif,
    responsibilityType: row.responsibilityType,
    specialResponsibilitySummary: row.specialResponsibilitySummary ?? undefined,
    startDate: row.startDate,
    endDate: row.endDate,
  });
}

export function mapAttorneysApiToSnapshots(items: any[] | any): ApoderadoSnapshot[] {
  const list = Array.isArray(items)
    ? items
    : (items as { attorneys?: any[]; attornies?: any[] })?.attorneys
      || (items as { attornies?: any[] })?.attornies
      || [];
  return (list || []).map(mapAttorneyApiToSnapshot);
}
